module.exports = __webpack_public_path__ + "media/images/flags/hi-5d5b49b5102d79cbc90f810cdd85e0f3.png";